import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActiveCard, Balance, PaymentParams, SubscriptionParams, User } from '../account.model';
import { NotificationService } from '../../shared/notification.service';
import { Ng1LiveChatService } from '../../shared/ng1/ng1-live-chat.service';
import { ConfigService } from '../../config/config.service';

@Component({
  selector: 'cc-payment-confirmer',
  templateUrl: './payment-confirmer.component.html',
  styleUrls: ['./payment-confirmer.component.scss']
})
export class PaymentConfirmerComponent implements OnInit, OnDestroy {
  @Input() paymentParams: PaymentParams;
  @Input() balance: Balance;
  @Input() subscriptionParams: SubscriptionParams;
  @Input() activeCard: ActiveCard;
  @Input() user: User;
  @Output() confirmed = new EventEmitter<boolean>();
  private $liveChatService;

  constructor(
    public notificationService: NotificationService,
    public configService: ConfigService,
    public ng1LiveChatService: Ng1LiveChatService
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.notificationService.dismiss();
  }

  confirm(agreed: boolean) {
    this.confirmed.emit(agreed);
  }

  paymentFailed() {
    return (
      this.paymentParams &&
      (this.paymentParams.status === 'cancelled' || this.paymentParams.status === 'requires_payment_method')
    );
  }

  paymentSuccess() {
    return this.paymentParams && this.paymentParams.status === 'succeeded';
  }

  contactSupport() {
    this.ng1LiveChatService.contactSupport();
  }
}
